import { z } from 'zod';
import { FlowEntityType } from '../flowDataAccess/index.js';
export const FlowDataAccessPatientInsuranceInformationFindAllQuerySchema = z
    .object({
    entityType: z.enum([
        FlowEntityType.EhrInformation,
        FlowEntityType.Encounter,
        FlowEntityType.PatientOrder,
    ]),
    // Not `z.uuid()`, though all three are: tightening it would turn today's 404 into a 400.
    entityId: z.string(),
})
    .strict();
export const FlowDataAccessPatientInsuranceInformationUpdateBodySchema = z
    .object({
    // joi's `Joi.string().required()` rejected the empty string; `z.string()` alone would not.
    planName: z.string().min(1),
})
    .strict();
//# sourceMappingURL=flowDataAccess.js.map